import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        find({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/issues/${id}`)
                    .then((res) => {
                        resolve(res.data.data.issue);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        updateMainProblem({ commit }, { id, main_problem }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/issues/${id}/main_problem`, { main_problem })
                    .then((res) => {
                        resolve(res.data.data.issue);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getHistory({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/issues/${id}/history`)
                    .then((res) => {
                        resolve(res.data.data.history);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    },

    getters: {},
};
